<template>
  <el-dialog title="新增题库" :visible="dialogFormVisible" width="800px" :close-on-click-modal="false" @close="close">
    <el-form ref="form" :model="form" :rules="rules" label-width="180px">
      <el-form-item label="排序" prop="sort">
        <el-input v-model.number="form.sort" autocomplete="off" placeholder="请输入排序号"></el-input>
      </el-form-item>
      <el-form-item label="题库标题" prop="title">
        <el-input v-model="form.title" autocomplete="off" placeholder="请输入题库标题"></el-input>
      </el-form-item>
      <el-form-item label="题库类型" prop="typeId">
        <el-select v-model="form.typeId" :placeholder="$t('common.pleaseSelect')">
          <el-option label="入职考试" :value="1"></el-option>
          <el-option label="专项考试" :value="2"></el-option>
        </el-select>
      </el-form-item>
      <el-form-item label="及格分数" prop="score">
        <el-input v-model.number="form.score" autocomplete="off" placeholder="请输入及格分数"></el-input>
      </el-form-item>
      <el-form-item label="题库参考资料" prop="body">
        <baidu-ueditor :content="form.body" @ueditor="getUeditor($event, 'registrationAgreement')"></baidu-ueditor>
      </el-form-item>
    </el-form>
    <div slot="footer" class="dialog-footer">
      <el-button size="medium" @click="close">{{ $t('common.cancel') }}</el-button>
      <el-button size="medium" type="primary" @click="save">{{ $t('common.confirm') }}</el-button>
    </div>
  </el-dialog>
</template>

<script>
import { learningSave, learningInfo } from '@/api/plugins.js';
import baiduUeditor from '@/plugins/baidu-ueditor.vue';
export default {
  components: { baiduUeditor },
  name: 'labelSave',
  data() {
    return {
      dialogFormVisible: false,
      form: {
        id: '',
        sort: null,
        title: '',
        typeId: '',
        score: '',
        body: ''
      },
      rules: {
        sort: [
          { required: true, message: '请输入排序号', trigger: 'blur' },
          { type: 'number', message: '排序必须为数字值', trigger: ['blur', 'change'] }
        ],
        title: [{ required: true, message: '请输入题库标题', trigger: 'blur' }],
        typeId: [{ required: true, message: '请选择题库类型', trigger: 'blur' }],
        score: [
          { required: true, message: '请输入及格分数', trigger: 'blur' },
          { type: 'number', message: '排序必须为数字值', trigger: ['blur', 'change'] }
        ]
      },
      title: ''
    };
  },
  created() {},
  methods: {
    init(id) {
      this.dialogFormVisible = true;
      if (id) {
        learningInfo({ id }).then((res) => {
          if (res.code == 1) {
            Object.assign(this.form, res.data);
          }
        });
      }
    },
    // 富文本数据回调
    getUeditor(msg) {
      this.form.body = msg;
    },
    //对话框关闭回调函数
    close() {
      this.$emit('callbackclose');
    },
    save() {
      this.$refs.form.validate((flag) => {
        if (flag) {
          learningSave(this.form).then((res) => {
            if (res.code == 1) {
              this.$baseMessage(res.msg, 'success');
              this.dialogFormVisible = false;
            }
          });
        }
      });
    }
  }
};
</script>
